import { Injectable } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class BroadcastService {
    newMessageBroadcasted: Subject<boolean> = new Subject<boolean>();
    constructor(
        private dataCollectorService: DataCollectorService
    ){}

    get broadcastUrl() :any{
        return `${this.dataCollectorService.baseurl()}/broadcast/mine`;
    }

    get createBroadcastURL() :any{
        return `${this.dataCollectorService.baseurl()}/broadcast`;
    }

    getBroadcastMessages(): Promise<any>{
        return new Promise((resolve: any) => {
            this.dataCollectorService.getData(this.broadcastUrl).subscribe((response: any)=>{
                resolve(response?.data);
            });
        })
    }
}
